// ----------Global----------
import { GlobalEffect } from './global.effect'
// ----------Auth----------
import { AuthEffect } from './auth/auth.effect'

export const effects = [GlobalEffect, AuthEffect]
